import Styles from './styles';
import { reactions as reactionsMap } from '../Reactions/reactions';

const { ReactionsContainer } = Styles;

type Props = {
  reactions: { reaction: string; timestamp: number }[];
  duration: number;
};

export const Reactions: React.FC<Props> = ({ reactions, duration }) => {
  return (
    <ReactionsContainer>
      <div
        style={{
          height: 4,
          position: 'absolute',
          top: '-50%',
          transform: 'translateY(-100%)',
          width: '100%',
        }}
      />

      {reactions.map((reaction, index) => {
        const leftPercent = (reaction.timestamp / duration) * 100;

        return (
          <div
            key={index}
            title={`@ ${reaction.timestamp}s`}
            style={{
              position: 'absolute',
              left: `${leftPercent}%`,
              transform: 'translateX(-50%)',
              top: -20,
            }}
          >
            {reactionsMap[reaction.reaction]}
          </div>
        );
      })}
    </ReactionsContainer>
  );
};
